"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.display = void 0;
const chalk = require("chalk");
const debug_1 = require("../debug");
const dep_graph_1 = require("@snyk/dep-graph");
const display_1 = require("./display");
const error_1 = require("../utils/error");
async function display(scanResults, testResults, errors, options) {
    if (errors.length > 0) {
        error_1.exitWith(error_1.ExitCode.Error, display_1.displayErrors(errors).join('\n'));
    }
    let result = [];
    let hasDependencies = false;
    let hasVulnerabilities = false;
    try {
        if (options === null || options === void 0 ? void 0 : options.path) {
            const prefix = chalk.bold.white(`\nTesting ${options.path}...\n`);
            result = result.concat(prefix);
        }
        if (options === null || options === void 0 ? void 0 : options.debug) {
            result = result.concat(display_1.displaySignatures(scanResults));
        }
        for (const testResult of testResults) {
            const depGraph = dep_graph_1.createFromJSON(testResult.depGraphData);
            const [dependencies, issues] = display_1.selectDisplayStrategy(options, depGraph, testResult);
            if (testResult.depGraphData.pkgs.length > 1) {
                hasDependencies = true;
            }
            if (testResult.issues.length > 0) {
                hasVulnerabilities = true;
            }
            result = result.concat(dependencies, issues);
        }
    }
    catch (error) {
        debug_1.debug(error.message || `Error displaying the results: ${error}`);
        error_1.exitWith(error_1.ExitCode.Error, 'Error displaying results.');
    }
    const output = result.join('\n');
    if (hasVulnerabilities) {
        error_1.exitWith(error_1.ExitCode.VulnerabilitiesFound, output, testResults);
    }
    if (!hasDependencies) {
        error_1.exitWith(error_1.ExitCode.NoSupportedFiles, `${output}\nCould not find any source code matching the Snyk database of open source dependencies in ${options === null || options === void 0 ? void 0 : options.path}\nPlease see our documentation for supported languages and target files: ${chalk.underline('https://snyk.co/udVgQ')} and make sure you are in the right directory.`);
    }
    return output;
}
exports.display = display;
//# sourceMappingURL=index.js.map